module.exports = __webpack_public_path__ + "resources/img/img_magic_line.ea911a550f06a96bee4ce97437aeb1b4.png";